import { EntityLinks, Goal, GoalType, LimitKeys } from '@griply/types';

import { hasGoalParent } from './goals/has-goal-parent';

export type GoalLimitKey =
  | LimitKeys.CreateGoal
  | LimitKeys.SubGoals
  | LimitKeys.CreateProject;

// Frozen goals are the backend's over-limit lock; counting them would block a user for good.
const isActive = ({
  completedAt,
  archivedAt,
  frozenAt,
  excludedFromLimits,
}: Goal): boolean =>
  !excludedFromLimits && !completedAt && !archivedAt && !frozenAt;

const isProject = ({ type }: Goal): boolean => type === GoalType.Project;

const hasParent = (goal: Goal, links: EntityLinks): boolean =>
  hasGoalParent(goal, { links });

const limitPredicates: Record<
  GoalLimitKey,
  (goal: Goal, links: EntityLinks) => boolean
> = {
  [LimitKeys.CreateGoal]: (goal, links) =>
    !isProject(goal) && !hasParent(goal, links),
  [LimitKeys.SubGoals]: (goal, links) =>
    !isProject(goal) && hasParent(goal, links),
  [LimitKeys.CreateProject]: isProject,
};

// A migrated goal's parents live in the relationships table; without links it counts as a root goal.
export const countGoalsTowardLimit = (
  goals: Goal[],
  limitKey: GoalLimitKey,
  links: EntityLinks,
): number =>
  goals.filter(
    (goal) => isActive(goal) && limitPredicates[limitKey](goal, links),
  ).length;
